import React from 'react';
import { withStyles } from '@material-ui/core/styles';

const styles = {
  icon: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  text: {
    color: '#2196f3'
  }
};

class CustomIcon extends React.Component {
  render = () => {
    return (
      <div className={this.props.classes.icon}>
        {this.props.icon}
        <span className={this.props.classes.text}>{this.props.text}</span>
      </div>
    );
  };
}

export default withStyles(styles)(CustomIcon);



// WEBPACK FOOTER //
// ./src/components/Icons/index.js